module.exports = __webpack_public_path__ + "img/er.bc20390b.png";